/**
 * User permission utilities for role-based UI (e.g. guest = view only).
 * Uses userData stored after login (medical user flow). Admin panel uses separate auth.
 */

const GUEST_ROLE = 'guest';

/**
 * Get parsed user data from localStorage (set after user login).
 * @returns {Object|null} { role, username, email, ... } or null
 */
export function getUserData() {
  try {
    const raw = localStorage.getItem('userData');
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

/**
 * Check if the current user (medical login) has the guest role.
 * Guest users can only view; they cannot add or edit.
 * @returns {boolean}
 */
export function isGuestUser() {
  const user = getUserData();
  return user && user.role === GUEST_ROLE;
}

/**
 * Check if the current user can edit/add/delete (i.e. is not a guest).
 * Use this to hide or disable add/edit/delete buttons and actions.
 * @returns {boolean}
 */
export function canEdit() {
  return !isGuestUser();
}
